module.exports = __webpack_public_path__ + "img/1fnZ_q4X5-g_CaKjqNr3NJigImJgjTsFm.7fcba31b.png";